import React from "react";
import { useTranslation } from "react-i18next";

export function Translate({ text }) {
    const { t } = useTranslation();
    return <>{t(text)}</>;
}

export default Translate;
